import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, MessagesSquare } from "lucide-react";
import { useApi } from "../../lib/useApi";
import { api } from "../../lib/api";
import { Loader, ErrorState, EmptyState, PageHeader } from "../../components/common/States";
import FeedbackThread from "../../components/feedback/FeedbackThread";
import { FeedbackRow } from "./UserDashboard";
import { STATUS } from "../../lib/labels";

export function UserFeedbacks() {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const { data, loading, error, reload } = useApi(`/me/feedbacks?status=${status}`);
  return (
    <div>
      <PageHeader title="Mes feedbacks" description="Tous les avis et réclamations déposés avec votre compte."
        actions={<select className="field-select w-56" value={status} onChange={(e) => setParams(e.target.value ? { status: e.target.value } : {})} data-testid="user-feedbacks-status-filter">
          <option value="">Tous les statuts</option>{Object.entries(STATUS).map(([k, s]) => <option key={k} value={k}>{s.label}</option>)}
        </select>} />
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && !data.length && <EmptyState icon={MessagesSquare} title="Aucun feedback" text={status ? "Aucun dossier avec ce statut." : "Vos dépôts effectués en étant connecté apparaîtront ici."} />}
      {data && data.length > 0 && <div className="card-surface divide-y">{data.map((f) => <FeedbackRow key={f.id} f={f} />)}</div>}
    </div>
  );
}

export function UserFeedbackDetail() {
  const { id } = useParams();
  const { data, loading, error, reload, setData } = useApi(`/me/feedbacks/${id}`);
  const reply = async (message) => { const { data: d } = await api.post(`/me/feedbacks/${id}/reply`, { message }); setData(d); };
  return (
    <div className="max-w-3xl">
      <Link to="/mon-espace/feedbacks" className="mb-6 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900" data-testid="user-feedback-back"><ArrowLeft className="h-4 w-4" />Mes feedbacks</Link>
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && <FeedbackThread fb={data} onReply={reply} attachmentBase={`/me/feedbacks/${id}/attachments`} />}
    </div>
  );
}
